import React, { useMemo, useState } from 'react';
import MatchPlayerStatsFilter, {
  playerStatsOptions,
} from './MatchPlayerStatsFilter';
import PlayersTable from './PlayersTable';
import { useLineup } from '../../hooks/matchdetails';
import SortableHeader from '../SortableHeader';

function MatchPlayerStats({ match, matchConfig }) {
  const [selectedStat, setSelectedStat] = useState('distance');
  const [team, setTeam] = useState('');
  const [playerLimit, setPlayerLimit] = useState(20);
  const [nationality, setNationality] = useState('Alla nationaliteter');

  const [sortKey, setSortKey] = useState('distance');
  const [sortDirection, setSortDirection] = useState('desc');

  const [lineups, lineupsLoading] = useLineup(
    match?.id,
    match?.configSeasonStartYear
  );

  const mapPlayer = (player) => ({
    ...player,
    hideStats: matchConfig?.hidePlayerStats?.[player.id] || null,
    distance: matchConfig?.hidePlayerStats?.[player.id]?.distance
      ? 1 // 0 hides the player
      : player.distance,
    maxSpeed: matchConfig?.hidePlayerStats?.[player.id]?.maxSpeed
      ? 1 // 0 hides the player
      : player.maxSpeed,
  });

  const playersStats = useMemo(() => {
    if (!lineups) return [];

    const players = [
      ...[
        ...lineups.homeTeamLineup.starting,
        ...lineups.homeTeamLineup.substitutes,
      ].map((player) => ({
        ...mapPlayer(player),
        teamAbbrv: match.homeTeamAbbrv,
        teamDisplayName: match.homeTeamName,
        teamLogo: match.homeTeamLogo,
      })),
      ...[
        ...lineups.visitingTeamLineup.starting,
        ...lineups.visitingTeamLineup.substitutes,
      ].map((player) => ({
        ...mapPlayer(player),
        teamAbbrv: match.visitingTeamAbbrv,
        teamDisplayName: match.visitingTeamName,
        teamLogo: match.visitingTeamLogo,
      })),
    ];

    return players;
  }, [lineups]);

  return (
    <div className="row tabs-content">
      <div className="col-12 px-0 tabs-column">
        <div className="data-container">
          <div
            className="data-container__row data-container__header px-2 px-lg-3 text-center"
            style={{
              borderRadius: '10px 10px 0 0 ',
              paddingTop: '0.813rem',
              paddingBottom: '0.813rem',
            }}
          >
            <div className=" heading-h5 text-transform-none">
              Spelarstatistik
            </div>
          </div>
          <MatchPlayerStatsFilter
            playersStats={playersStats}
            team={team}
            setTeam={setTeam}
            nationality={nationality}
            setNationality={setNationality}
            setPlayerLimit={setPlayerLimit}
            selectedStat={selectedStat}
            setSelectedStat={setSelectedStat}
          />
          <div>
            <div className="stats-table">
              <div
                className="stats-table__row d-none d-md-flex"
                style={{ minHeight: '54px' }}
              >
                <div className="col-1 col-md-1 heading-stats-name text-center">
                  Ranking
                </div>
                <div className="col-9 col-md-4 heading-stats-name">Spelare</div>
                <div className="col-auto col-md-3 d-none d-md-block heading-stats-name">
                  Lag
                </div>

                {playerStatsOptions.map((option) => (
                  <SortableHeader
                    key={`psh-${option.key}`}
                    sortable
                    sortKey={option.key}
                    classes="col-2 col-md-2 heading-stats-name text-center"
                    activeSortKey={sortKey}
                    direction={sortDirection}
                    setDirection={setSortDirection}
                    setSortKey={setSortKey}
                    label={option.name}
                  />
                ))}
              </div>
              <PlayersTable
                playersStats={playersStats}
                playersStatsLoading={lineupsLoading}
                playerLimit={playerLimit}
                setPlayerLimit={setPlayerLimit}
                orderBy={sortKey}
                orderDirection={sortDirection}
                team={team}
                nationality={nationality}
                selectedStat={selectedStat}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MatchPlayerStats;
